import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Materials = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  height: calc(100% - 84px);
  padding: 30px 15px 15px;
  background-color: ${COLORS.black};
  overflow: hidden;
`;

export default Materials;
